export default __webpack_public_path__ + "static/media/id_badge.a2af8b29.svg";